export default __webpack_public_path__ + "static/media/top-arrow.590d197f.svg";